<button class="pink-yellow-gradient" (click)="onClick()"><ng-content></ng-content></button>
